import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Heart, Star, Clock, Bike } from "lucide-react";

export default function FavoritesPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/favorites").then((r) => setItems(r.data)).catch((e) => toast.error(formatApiError(e))).finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-6xl mx-auto px-5 sm:px-8 py-6 sm:py-10 pb-32">
      <h1 className="font-display text-4xl font-bold">Favorites</h1>
      <p className="text-neutral-500 mt-1">Your most-loved island kitchens.</p>

      {loading ? (
        <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {Array.from({ length: 3 }).map((_, i) => <div key={i} className="skeleton h-56 rounded-3xl" />)}
        </div>
      ) : items.length === 0 ? (
        <div className="mt-16 text-center">
          <div className="mx-auto w-20 h-20 rounded-3xl bg-eatup-green/10 flex items-center justify-center">
            <Heart className="w-10 h-10 text-eatup-green" />
          </div>
          <h3 className="mt-6 font-display text-2xl font-bold">No favorites yet</h3>
          <p className="text-neutral-500 mt-2">Tap the heart on any restaurant to save it.</p>
        </div>
      ) : (
        <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((r) => (
            <Link
              key={r.restaurant_id}
              to={`/restaurant/${r.restaurant_id}`}
              data-testid={`fav-card-${r.restaurant_id}`}
              className="group rounded-3xl overflow-hidden bg-white card-shadow card-shadow-hover"
            >
              <div className="relative h-44 overflow-hidden">
                <img src={r.image_url} alt={r.name} className="w-full h-full object-cover group-hover:scale-105 transition duration-700" />
                <div className="absolute top-3 right-3 w-9 h-9 rounded-full bg-eatup-green text-white flex items-center justify-center">
                  <Heart className="w-4 h-4 fill-white" />
                </div>
              </div>
              <div className="p-5">
                <div className="font-display font-bold">{r.name}</div>
                <p className="text-xs text-neutral-500 mt-1">{r.tagline}</p>
                <div className="mt-3 flex items-center gap-3 text-xs text-neutral-600">
                  <span className="flex items-center gap-1"><Star className="w-3 h-3 fill-eatup-yellow text-eatup-yellow" /> {r.rating}</span>
                  <span className="flex items-center gap-1"><Clock className="w-3 h-3" /> {r.eta_minutes} min</span>
                  <span className="flex items-center gap-1"><Bike className="w-3 h-3" /> ${r.delivery_fee?.toFixed(2)}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
